import React from "react";
import { Document, Page } from "react-pdf";
import { CircularProgress } from "@mui/material";;
import { Logger } from "@/lib/logger/Logger";
import "@/lib/utils/pdf-worker";

interface PdfPreviewProps {
	url: string;
	width?: number;
}

export const PdfPreview: React.FC<PdfPreviewProps> = ({ url, width }) => {
	return (
		<Document
			file={url}
			onLoadSuccess={() => {}}
			onLoadError={(error) => Logger.error("PDF load error", {}, error)}
			loading={<CircularProgress size={20} />}
		>
			<Page
				pageNumber={1}
				renderAnnotationLayer={false}
				renderTextLayer={false}
				noData={<p>Keine Daten.</p>}
				width={width}
			/>
		</Document>
	);
};
